export default __webpack_public_path__ + "static/media/circle.f4e3be34.png";